import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { toTitleCase } from './Update';
import { useSelector } from 'react-redux';
import MainCard from 'components/MainCard';
import { useTheme } from '@mui/material/styles';
import { groupBy, map, mapValues } from 'lodash';
import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { filterChildOptionLabel } from 'pages/globals/global';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import CustomDateInput from 'components/inputs/CustomDateInput';
import DetailPageHeader from 'components/header/DetailPageHeader';
import CustomSelectInput from 'components/inputs/CustomSelectInput';
import { Button, Col, Flex, Form, Input, Row, Select, Spin } from 'antd';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useGetLynFormDataMutation } from 'store/features/comptroller/comptrollerApi';
import { Box, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import {
	useGetSingleIdentityMutation,
	useGetLynFormPropertyMutation,
	useGetCheckAllUserCheckByIdentitiesMutation,
} from 'store/features/process/processApi';

// ... (All your constants are correct)
export const queryNameMap = {
	'PROPERTY_Identity-Opt_band': 'Bands',
	'PROPERTY_Identity-Opt_position': 'leavePolicyPositions',
	'PROPERTY_Identity-Opt_function': 'leavePolicyFunctions',
	'PROPERTY_Identity-Opt_userId': 'leavePolicyUsers',
};
export const leaveTypeOptions = [
	{ key: 1, label: 'Annual Leave', value: 'annual' },
	{ key: 2, label: 'Sick Leave', value: 'sick' },
	{ key: 3, label: 'Casual Leave', value: 'casual' },
	{ key: 4, label: 'Maternity', value: 'maternity' },
	{ key: 5, label: 'Paternity', value: 'paternity' },
	{ key: 6, label: 'Religious', value: 'religious' },
	{ key: 7, label: 'Study', value: 'study' },
	{ key: 8, label: 'Compensatory', value: 'compensatory' },
	{ key: 9, label: 'Carryovers', value: 'carryovers' },
	{ key: 10, label: 'Leave Encashment', value: 'leaveEncashment' },
];
export const leaveCategoryOptions = [
	{
		key: 1,
		label: 'Regular Leave',
		value: 'regular',
		connectOptions: [
			{ key: 1, label: 'Annual Leave', value: 'annual' },
			{ key: 2, label: 'Sick Leave', value: 'sick' },
			{ key: 3, label: 'Casual Leave', value: 'casual' },
		],
	},
	{
		key: 2,
		label: 'Special Leave',
		value: 'special',
		connectOptions: [
			{ key: 4, label: 'Maternity Leave', value: 'maternity' },
			{ key: 5, label: 'Paternity Leave', value: 'paternity' },
			{ key: 6, label: 'Religious Leave', value: 'religious' },
			{ key: 7, label: 'Study Leave', value: 'study' },
			{ key: 8, label: 'Compensatory Leave', value: 'compensatory' },
		],
	},
	{
		key: 3,
		label: 'Leave Governance',
		value: 'governance',
		connectOptions: [
			{ key: 9, label: 'Carryovers', value: 'carryovers' },
			{ key: 10, label: 'Leave Encashment', value: 'leaveEncashment' },
			{ key: 11, label: 'Probation Period', value: 'probationPeriod' },
			{ key: 12, label: 'Leave Accrual', value: 'leaveAccrual' },
		],
	},
];

// ... (Your helper functions are correct)
function groupAndExtractIdentities(data) {
	const groupedByContext = groupBy(data, 'identityContext');
	const result = mapValues(groupedByContext, (group) => map(group, 'identityValue'));
	return result;
}

const transformPolicyData = (policyData) => {
	const result = {
		users: [],
		functions: [],
		positions: [],
		jobBands: [],
	};
	const policyTable = policyData?.policyTable;
	if (!Array.isArray(policyTable)) {
		console.error("Input data does not contain a valid 'policyTable' array.");
		return result;
	}
	const modifiedResults = groupAndExtractIdentities(policyTable);
	return modifiedResults ?? result;
};

function renameKeyMutable(data) {
	if (Object.prototype.hasOwnProperty.call(data, 'band')) {
		data.jobBands = data.band || [];
		data.users = data.userId || [];
		data.functions = data.function || [];
		data.positions = data.position || [];
		delete data.band;
		delete data.userId;
		delete data.function;
		delete data.position;
	}
	return data;
}

function Create() {
	const theme = useTheme();
	const [form] = Form.useForm();
	const { state } = useLocation();
	const navigate = useNavigate();
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState();
	const [filteredLeaveTypes, setFilteredLeaveTypes] = useState([]);
	// console.log(filteredLeaveTypes, 'filteredLeaveTypes1112');
	const selectedCategory = Form.useWatch('policyCategory', form);
	const [GetSingleIdentity, { isLoading: isSingleCaseLoading, isError: isCreateError, error: createError, isSuccess: isCreateSuccess }] =
		useGetSingleIdentityMutation();
	const [statusChecker] = useGetCheckAllUserCheckByIdentitiesMutation();
	const isInitialMount = useRef(true);

	const [leaveCategory, setLeaveCategory] = useState('');

	const onSubmitHandler = async (payload) => {
		const { effectiveDateTime, ...rest } = payload;
		// console.log(payload,'payload5566');
		const transformedTable = payload.policyTable
			?.map((row) => {
				if (!row || !row['PROPERTY_Identity-Opt']) {
					return null;
				}
				const identityContext = row['PROPERTY_Identity-Opt'].split('_').pop();
				const { identityLabel, valueLabel, ...restOfRow } = row;
				return {
					...restOfRow,
					identityContext: identityContext,
				};
			})
			.filter(Boolean);

		const modifiedPayload = {
			effectiveDateTime: effectiveDateTime,
			...rest,
			policyTable: transformedTable,
		};
		const policyDataCheck = renameKeyMutable(transformPolicyData(modifiedPayload));
		const checkResult = await statusChecker(policyDataCheck);

		// if (!checkResult?.data?.result) {
		// 	toast.error('Failed! Please check the policy table for errors.', toastConfig);
		// 	return;
		// }
		setSubmitData(modifiedPayload);
		setShowModal(true);
	};

	const onModalOkHandler = () => {
		GetSingleIdentity({
			operation: 'add-single',
			processCode: state?.processCode || '10127',
			suffixCode: '',
			data: submitData,
		});
		navigate(-1);
	};
	useEffect(() => {
		if (isCreateSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			navigate(-1);
		}
		if (isCreateError) {
			if (createError?.data?.code === '501') {
				toast.error(createError?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isCreateSuccess, createError, isCreateError]);
	// --- 1. FINALIZED EFFECT FOR INITIAL DATA LOADING ---
	useEffect(() => {
		// Ensure we have all the data we need from the state object
		if (state?.data?.leaveData?.category && state.data.leaveData.leaveType) {
			const initialCategoryValue = state.data.leaveData.category; // Correct: 'governance'

			// THE FIX: Use the key that holds the VALUE ('leaveKey'), and make its casing match your options.
			const initialLeaveTypeValue = state.data.leaveData.leaveType.toLowerCase(); // 'carryOvers' -> 'carryovers'

			const categoryData = leaveCategoryOptions.find((cat) => cat.value === initialCategoryValue);

			// Set the options for the dependent dropdown FIRST.
			if (categoryData) {
				setFilteredLeaveTypes(categoryData.connectOptions || []);
			}
			// console.log(categoryData, 'categoryData1122');
			setLeaveCategory(categoryData?.value || '');
			// Now, set the form fields with the correct values.
			form.setFieldsValue({
				policyCategory: initialCategoryValue,
				leaveType: initialLeaveTypeValue,
			});
		}
	}, [state, form]);

	// --- 2. EFFECT FOR HANDLING USER-DRIVEN CHANGES (This logic is correct) ---
	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}

		// if (selectedCategory) {
		// 	const categoryData = leaveCategoryOptions.find((cat) => cat.value === selectedCategory);
		// 	setFilteredLeaveTypes(categoryData?.connectOptions || []);
		// 	form.setFieldsValue({ leaveType: undefined });
		//
		// 	const currentPolicies = form.getFieldValue('policyTable') || [];
		// 	if (currentPolicies.length > 0) {
		// 		const updatedPolicies = currentPolicies.map(policyTable => ({
		// 			...policyTable,
		// 			recurrence: undefined,
		// 		}));
		// 		form.setFieldsValue({ policyTable: updatedPolicies });
		// 	}
		// } else {
		// 	setFilteredLeaveTypes([]);
		// }
	}, [selectedCategory, form]);

	return (
		<Box>
			<DetailPageHeader title={`Create ${toTitleCase(state?.data?.leaveType || '')} Policy`} />

			<Spin spinning={isSingleCaseLoading} style={{ maxHeight: '100%' }}>
				<MainCard>
					<Form
						form={form}
						id="policy-create"
						layout="vertical"
						initialValues={{
							policyTable: [null],
						}}
						onFinish={onSubmitHandler}
					>
						<AntdValuePreview form={form} show={true} />

						<Row gutter={[16, 0]}>
							{/* <Col xs={24} md={8} lg={6}>
								<CustomInputLabel label="Category" head={true} />
							</Col> */}
							<Col xs={24} sm={24} md={24} xl={24}>
								<CustomSelectInput
									label="Category"
									name="policyCategory"
									// Make category selectable by the user in Create mode
									disabled
									rules={[
										{
											required: true,
											message: 'Leave category is required',
										},
									]}
								>
									{leaveCategoryOptions.map((item, index) => (
										<Select.Option key={index} value={item?.value}>
											{item?.label}
										</Select.Option>
									))}
								</CustomSelectInput>
							</Col>
							{/* <Col xs={24} md={8} lg={6}>
								<CustomInputLabel label="Leave Type" head={true} />
							</Col> */}
							<Col xs={24} sm={24} md={24} xl={24}>
								<CustomSelectInput
									label="Leave Type"
									name="leaveType"
									disabled
									rules={[
										{
											required: true,
											message: 'Leave type is required',
										},
									]}
								>
									{filteredLeaveTypes.map((item, index) => (
										<Select.Option key={index} value={item?.value}>
											{item?.label}
										</Select.Option>
									))}
								</CustomSelectInput>
							</Col>
							{/* ... Rest of your JSX is correct and can remain unchanged ... */}
							{/* <Col xs={24} md={8} lg={6}>
								<CustomInputLabel label="Effective Date" head={true} />
							</Col> */}
							<Col xs={24} sm={24} md={24} xl={24}>
								<CustomDateInput
									form={form}
									label="Effective Date"
									name="effectiveDateTime"
									rules={[
										{
											required: true,
											message: 'Effective date field is required',
										},
									]}
								/>
							</Col>
							<Col xs={24}>
								<Form.List name="policyTable">
									{(fields, { add, remove }) => (
										<TableContainer
											sx={{
												mb: 3,
												'& table, & th, & td': {
													border: '1px solid #e0e0e0',
													borderCollapse: 'collapse',
												},
												'& th': {
													py: '5px',
													px: '11px',
												},
												'& td': {
													p: '5px',
												},
												'& td .ant-form-item': {
													marginBottom: '0px',
												},
												'& .condition-msg': {
													py: 3,
												},
												overflow: 'hidden',
												'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '20%' } /* From/From Month */,
												'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '20%' } /* To/To Month */,
												'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '20%' } /* Amount/Monthly Adjustment */,
												'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '20%' } /* Remarks/Total Amount */,
												'& th:nth-of-type(5), & td:nth-of-type(5)': { width: '20%' } /* Action */,
												'& table': { width: '100%' } /* Ensure table takes full container width */,
											}}
										>
											<Table
												sx={{
													'& .MuiTableBody-root .MuiTableCell-root': {
														p: 0.5,
													},
													'& .ant-form-item': {
														marginBottom: 0,
													},
												}}
											>
												<TableHead>
													<TableRow sx={{ backgroundColor: '#e5e5e5' }}>
														{/*		   sx={{ minWidth: '4.5rem' }}></TableCell>*/}
														<TableCell sx={{ minWidth: '10rem', textAlign: 'center' }}>Identity</TableCell>
														<TableCell sx={{ minWidth: '10rem', textAlign: 'center' }}>Value</TableCell>
														<TableCell sx={{ minWidth: '10rem', textAlign: 'center' }}>Entitlement</TableCell>
														{leaveCategory !== 'governance' && (
															<TableCell sx={{ minWidth: '10rem', textAlign: 'center' }}>
																{`${selectedCategory === 'regular' ? 'Accrual' : 'Recurrence'}`}
															</TableCell>
														)}
														<TableCell sx={{ minWidth: '10rem', textAlign: 'center' }}>Actions</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{fields?.map((field, index) => (
														<TableRow key={index}>
															<TableCell sx={{ verticalAlign: 'top', width: '10rem' }}>
																<PolicyTableSelect
																	name={[field.name, 'PROPERTY_Identity-Opt']}
																	displayNameCode={[field.name, 'identityLabel']}
																	code="PROPERTY_Identity-Opt"
																	rules={[
																		{
																			required: true,
																			message: 'Identity is required',
																		},
																	]}
																/>
															</TableCell>

															<TableCell sx={{ verticalAlign: 'top', width: '10rem' }}>
																<Form.Item
																	noStyle
																	shouldUpdate={(prevValues, currentValues) =>
																		prevValues?.policyTable?.[index]?.['PROPERTY_Identity-Opt'] !==
																		currentValues?.policyTable?.[index]?.['PROPERTY_Identity-Opt']
																	}
																	rules={[
																		{
																			required: true,
																			message: 'Value is required',
																		},
																	]}
																>
																	{({ getFieldValue }) => (
																		<PolicyTableSelect
																			isDependent={true}
																			name={[field.name, 'identityValue']}
																			displayNameCode={[field.name, 'valueLabel']}
																			code={
																				queryNameMap?.[
																					getFieldValue(['policyTable', index, 'PROPERTY_Identity-Opt'])
																				] ?? null
																			}
																			rules={[
																				{
																					required: true,
																					message: 'Value is required',
																				},
																			]}
																		/>
																	)}
																</Form.Item>
															</TableCell>

															<TableCell
																sx={{
																	verticalAlign: 'top',
																	minWidth: '10rem',
																}}
															>
																<Form.Item
																	style={{ margin: 0 }}
																	name={[field.name, 'entitlementDays']}
																	rules={[
																		{
																			required: true,
																			message: 'Entitlement is required',
																		},
																	]}
																>
																	<Input placeholder="Write here" />
																</Form.Item>
															</TableCell>
															{leaveCategory !== 'governance' && (
																<TableCell
																	sx={{
																		verticalAlign: 'top',
																		minWidth: '10rem',
																	}}
																>
																	<Form.Item
																		name={[field.name, 'recurrence']}
																		style={{ margin: 0 }}
																		rules={[
																			{
																				required: true,
																				message: 'Recurrence is required',
																			},
																		]}
																	>
																		{selectedCategory === 'regular' ? (
																			<Select
																				allowClear
																				placeholder="Select recurrence"
																				style={{ width: '100%' }}
																			>
																				<Select.Option value="annually">Annually</Select.Option>
																				<Select.Option value="monthly">Monthly</Select.Option>
																			</Select>
																		) : selectedCategory === 'special' ? (
																			<Input
																				type="number"
																				placeholder="Enter number value"
																				style={{ width: '100%' }}
																			/>
																		) : (
																			<Select
																				allowClear
																				placeholder="Select recurrence"
																				style={{ width: '100%' }}
																			>
																				<Select.Option value="annually">Annually</Select.Option>
																				<Select.Option value="monthly">Monthly</Select.Option>
																			</Select>
																		)}
																	</Form.Item>
																</TableCell>
															)}
															<TableCell
																align="center"
																sx={{
																	position: 'relative',
																	padding: '0 !important',
																}}
															>
																<Box
																	sx={{
																		position: 'absolute',
																		top: 0,
																		left: 0,
																		width: '100%',
																		height: '100%',

																		display: 'flex',
																		justifyContent: 'center',
																		alignItems: 'center',
																		gap: 2,
																	}}
																>
																	{index !== 0 && (
																		<Tooltip title="Delete Row">
																			<MinusCircleOutlined
																				style={{
																					fontSize: '20px',
																					color: '#ff4d4f',
																					cursor: 'pointer',
																				}}
																				onClick={() => remove(index)}
																			/>
																		</Tooltip>
																	)}
																	{index === fields.length - 1 && (
																		<Tooltip title="Add Row">
																			<PlusCircleOutlined
																				style={{
																					fontSize: '20px',
																					color: '#1890ff',
																					cursor: 'pointer',
																				}}
																				onClick={() => add()}
																			/>
																		</Tooltip>
																	)}
																</Box>
															</TableCell>
														</TableRow>
													))}
												</TableBody>
											</Table>
										</TableContainer>
									)}
								</Form.List>
							</Col>
							<Col xs={24}>
								<Flex justify="end">
									<Button type="primary" htmlType="submit" style={{ backgroundColor: theme.palette.lynTheme.main }}>
										Submit
									</Button>
								</Flex>
							</Col>
						</Row>
					</Form>
				</MainCard>
			</Spin>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					modalData={{
						head: 'Leave Policy',
						label: 'Do you want to proceed?',
					}}
					setShowModal={setShowModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</Box>
	);
}

export default Create;

// PolicyTableSelect component remains unchanged
export const PolicyTableSelect = ({ name, displayNameCode, code, rules, dependentCode, dp, isDependent = false }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();
	const [options, setOptions] = useState(isDependent ? [] : null);
	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();
	const onSelectHandler = (value) => {
		if (displayNameCode) {
			const label = form.getFieldValue(value);
			form.setFieldValue(['policyTable', ...displayNameCode], label);
		}
	};
	const onChangeHandler = () => {
		if (dependentCode) {
			form.setFieldValue(dependentCode);
		}
	};
	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || dp?.processCode,
				processVersion: state?.processVersion || dp?.processVersion,
				propertyCode: code,
				companyCode,
				status: 'Active',
			});
		} else if (code && userId) {
			GetLynFormData({
				name: code,
				userId,
			});
		}
	}, [code, userId]);
	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties ?? []);
		}
		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results ?? []);
		}
	}, [lynProperty, lynFormData]);
	return (
		<>
			<Form.Item name={name} style={{ margin: 0 }} rules={rules}>
				{options === null ? (
					<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
				) : (
					<Select
						allowClear
						style={{ width: '100%' }}
						showSearch
						filterOption={filterChildOptionLabel}
						onChange={onChangeHandler}
						onSelect={onSelectHandler}
						placeholder="Select from the list"
					>
						{options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))}
					</Select>
				)}
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};
